<template>
  <ProjectInfo></ProjectInfo>
</template>

<script>

  import ProjectInfo from '../components/ProjectInfo';

  export default {
    name: "InfoView",

    components: {
      ProjectInfo
    }
  }
</script>

<style scoped>

</style>
